import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface GetActiveMiniTournamentPayload {
  meetingId: string;
  occurenceId: string;
}

export interface ActiveMiniTournament {
  tournament_id: number;
  name: string;
  start_date: string;
  end_date: string;
  created_by: number;
}

export interface GetActiveMiniTournamentResponse {
  success: boolean;
  tournament: ActiveMiniTournament | null;
  error?: string;
}

export default function useGetActiveMiniTournamentApi(
  handleOnSuccess?: (data: GetActiveMiniTournamentResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  GetActiveMiniTournamentResponse,
  unknown,
  GetActiveMiniTournamentPayload
> {
  return useMutation<
    GetActiveMiniTournamentResponse,
    unknown,
    GetActiveMiniTournamentPayload
  >(
    async (payload: GetActiveMiniTournamentPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_active_mini_tournament/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: GetActiveMiniTournamentResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch active mini tournament:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
